import { HeaderResults } from "../../components/Header/HeaderResults"
import { ResultsSidebar } from "../../components/Header/ResultsSidebar"

export const Step = ({
    header,
    children,
    values,
}) => {
    const className = header.section.trim().replaceAll(" ", "-").toLowerCase();
    return (
        <section className={`results container ${className}`}>
            <HeaderResults
                index={header.index}
                sectionName={header.section}
                name={header.company}
            />
            <article className="results__step">
                <section className={values ? "results__content values" : "results__content"}>
                    {children}
                </section>
                <ResultsSidebar activeEl={header.section} />
            </article>
        </section>
    )
}